<p class="modal-title">In-retirement healthcare expenses</p>
<div class="modal-close" (click)="onClose()">
    <img alt="Close" src="../../../assets/icons/circle-x.svg" />
</div>
<div>
   <!--  <div class="modal-close" (click)="onClose()">
        <div>
            <img src="../../../assets/icons/circle-x.svg" />
        </div>
    </div> -->
    <div>
        <!-- <p class="step-title">In-retirement healthcare expenses</p> -->
        <p class="step-subtitle">
            HSA-eligible expenses below consist of Medicare Part B premiums (doctor visits and tests),
            Medicare Part D premiums (prescription drugs) and other expected out-of-pocket expenses like copays and
            deductibles.
            It's assumed that Medicare Part A premiums (hospitalizations) are funded by payroll tax during your working
            years.
            Potential income-based surcharges on Medicare Part B and D premiums are not included in calculations. 
        </p>
    </div>
    <div class="toggle-wrapper">
        <div class="toggle">
            <div *ngIf="isFuture">
                <span style="color: #8890A6; font-weight: 300 !important;">Today's dollars </span>
            </div>
            <div *ngIf="!isFuture">
                <span>Today's dollars </span>
            </div>

            <mat-slide-toggle (change)="toggle()" (keyup.enter)="toggle()" tabindex=0 [checked]="isFuture"></mat-slide-toggle>
            <div *ngIf="!isFuture" style="display: flex;">
                <span style="color: #8890A6; font-weight: 300 !important;"> Future dollars </span>
                <span class="info-icon" (click)="inRetirementCostInfo()" (keyup.enter)="inRetirementCostInfo()" tabindex=0></span>
            </div>
            <div *ngIf="isFuture" style="display: flex;">
                <span> Future dollars </span>
                <span class="info-icon" (click)="inRetirementCostInfo()" (keyup.enter)="inRetirementCostInfo()" tabindex=0></span>
            </div>
        </div>
    </div>

    <!-- <div mat-dialog-content> -->

    <table mat-table [dataSource]="dataSource.inRetirementHCExp" class="mat-elevation-z8">
        <!-- Year(age) Column -->
        <ng-container matColumnDef="year(age)">
            <th mat-header-cell *matHeaderCellDef> Year (age) </th>
            <td mat-cell *matCellDef="let element">
                <div *ngIf="!isMarried">
                    {{element.year}} ({{element.age}})
                </div>
                <div *ngIf="isMarried">
                    {{element.year}} ({{(element.age > 0) ? element.age : ' -- '}}, {{(element.spouseAge > 0) ? element.spouseAge : ' -- '}})
                </div>

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Part B premiums Column -->
        <ng-container matColumnDef="partB" *ngIf="!isMobile">
            <th mat-header-cell *matHeaderCellDef> Part B premiums </th>
            <td mat-cell *matCellDef="let element"> {{element.partB | currency : 'USD' : 'symbol' : '1.0-0'}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Part D premiums Column -->
        <ng-container matColumnDef="partD" *ngIf="!isMobile">
            <th mat-header-cell *matHeaderCellDef> Part D premiums </th>
            <td mat-cell *matCellDef="let element"> {{element.partD | currency : 'USD' : 'symbol' : '1.0-0'}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Co-pays and deductibles Column -->
        <ng-container matColumnDef="copaysAndDeductibles" *ngIf="!isMobile">
            <th mat-header-cell *matHeaderCellDef> Co-pays and deductibles </th>
            <td mat-cell *matCellDef="let element">
                {{element.copaysAndDeductibles | currency : 'USD' : 'symbol' : '1.0-0'}} </td>
            <td mat-footer-cell *matFooterCellDef>
                <span class="footer-black-font">TOTAL:</span>
            </td>
        </ng-container>

        <!-- Household total Column -->
        <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef> Household total </th>
            <td mat-cell *matCellDef="let element"> {{element.total | currency : 'USD' : 'symbol' : '1.0-0'}} </td>
            <td mat-footer-cell *matFooterCellDef>
                <span class="footer-black-font" *ngIf="!isMobile">{{dataSource.total | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                <span class="footer-black-font" *ngIf="isMobile">TOTAL: {{dataSource.total | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="averageOne">
            <th mat-footer-cell *matFooterCellDef class="footer-cell" colspan="1"></th>
        </ng-container>
        <ng-container matColumnDef="averageTwo" *ngIf="!isMobile">
            <th mat-footer-cell *matFooterCellDef class="footer-cell" colspan="1"></th>
        </ng-container>
        <ng-container matColumnDef="averageThree" *ngIf="!isMobile">
            <th mat-footer-cell *matFooterCellDef class="footer-cell" colspan="1"></th>
        </ng-container>
        <ng-container matColumnDef="averageFour" *ngIf="!isMobile">
            <th mat-footer-cell *matFooterCellDef class="footer-cell" colspan="1">
                <span class="footer-font">AVERAGE:</span>
            </th>
        </ng-container>
        <ng-container matColumnDef="average-value">
            <th mat-footer-cell *matFooterCellDef class="footer-cell" colspan="1">
                <span class="footer-font" *ngIf="!isMobile">{{dataSource.average | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                <span class="footer-font" *ngIf="isMobile">AVERAGE: {{dataSource.average | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
            </th>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        <tr mat-footer-row
            *matFooterRowDef="(isMobile) ? ['averageOne', 'average-value'] : ['averageOne','averageTwo', 'averageThree', 'averageFour', 'average-value']"></tr>
    
    </table>
    <!-- </div> -->
    <div class="life-expect-text">
        <p>
            <span *ngFor="let details of expenseDetails">
                <span [innerHtml]="details"></span>&nbsp;
            </span>
        </p>
    </div>



    <!-- <div mat-dialog-content> -->
    <!-- <table mat-table [dataSource]="inRetirementHCCost">
            <ng-container matColumnDef="year">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let inRetirementHCCost"> {{inRetirementHCCost.year}} </td>
            </ng-container>
        </table>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr> -->

    <!-- </div> -->

</div>